<template>
  <v-form>
    <v-container>
      <v-layout row wrap>
        <v-flex xs12>
          <v-text-field
            label="店舗データファイル"
            @click="pickFile"
            v-model="fileName"
            prepend-icon="attach_file"
            hint="CSVファイル"
            v-validate="'required'"
            data-vv-name="userId"
            :error-messages="errors.collect('storeCode')"
          ></v-text-field>
          <input
            type="file"
            ref="file"
            style="display: none"
            accept=".csv, .xls"
            @change="onFileChange($event)"
          />
          
          <v-btn block color="success" dark :loading="loading1" @click="fileUpload()">
            <v-icon dark left>cloud_upload</v-icon>アップロード実行
          </v-btn>
        </v-flex>
      </v-layout>
      <v-layout row wrap>
        <v-flex xs6 sm6>
          <v-switch label="廃番商品も表示する" color="info" value="info" hide-details v-model="dispDeleted"></v-switch>
        </v-flex>
      </v-layout>
      <div style="height: 20px;"></div>

      <v-layout row wrap>
        <v-flex xs12 sm3>
          <v-btn block color="#4C728A" dark :to="{ name: 'admin/new-admin-menu' }">
            <v-icon color="black" left>home</v-icon>{{ $t('home-btn') }}
          </v-btn>
        </v-flex>
        <v-flex xs12 sm3>
          <v-btn block color="primary" dark @click="downloadCsv()">
            <v-icon dark left>get_app</v-icon>{{ $t('download-btn') }}
          </v-btn>
        </v-flex>
        <v-flex xs12 sm3></v-flex>        
      </v-layout>
      <br />

      <div style="height: 10px;"></div>
      <v-layout row wrap>
        <v-flex xs12 sm6>
          <v-select
            v-model="selectSupplier"
            :items="suppliers"
            label="取引先選択"
            item-text="supplierName"
            item-value="supplierCode"
            :sort-by="['supplierCode']"
            :sort-desc="[false]"
            return-object
          ></v-select>
        </v-flex>
      </v-layout>

      <v-data-table
        :headers="headers"
        :items="stores"
        class="elevation-1"
        hide-actions
        :customFilter="customFilter"
        :search="selectSupplier"
        :loading="loadingData"
      >
        <!-- :search="selectStoreCode" :filter="filter" :customFilter="customFilter" -->
        <template slot="headerCell" slot-scope="props">
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <span v-on="on">{{ props.header.text }}</span>
            </template>
            <span>{{ props.header.text }}</span>
          </v-tooltip>
        </template>
        <template v-slot:items="props">
          <tr>
            <td class="text-xs-left">{{ props.item.storeName }}</td>
            <td class="text-xs-left">{{ props.item.deliveryCode }}</td>
            <td class="text-xs-left">{{ props.item.postCode }}</td>
            <td class="text-xs-left">{{ props.item.shippingCarrierCode }}</td>
            <td class="text-xs-left">{{ props.item.deliveryRouteCode1 }}</td>
            <td class="text-xs-left">{{ props.item.deliveryRouteCode2 }}</td>
          </tr>
        </template>
      </v-data-table>
    </v-container>
  </v-form>
</template>

<script>
import ServerApiCallService from '@/services/ServerApiCallService.js'
import axios from 'axios'

export default {
  created() {
    console.log('created')
    ServerApiCallService.setAppJs(this.$parent.$parent.$parent)
    this.getAllStores()
  },
  methods: {
    customSort(items, index, isDesc) {
      items.sort((a, b) => {
        if (a.supplierCode < b.supplierCode) {
          return -1
        } else if (a.supplierCode > b.supplierCode) {
          return 1
        }
        if (a.storeName < b.storeName) {
          return -1
        } else if (a.storeName > b.storeName) {
          return 1
        }
        return 0
      })
      return items
    },
    getAllStores() {
      console.log('refresh stores')
      let thisObj = this
      // 初期表示時の
      this.loadingData = true

      // 모든 거래처 정보 가져오기
      ServerApiCallService.suppliers()
        .then(response => {
          thisObj.suppliers = response.data.suppliers

          thisObj.suppliers.unshift({
            supplierCode: '#',
            supplierName: '全て(使える店舗)'
          })

          // add kium 20231121: 삭제점포 추가
          thisObj.suppliers.splice(1,0,{
            supplierCode: 'r',
            supplierName: '使えない店舗'
          })
        })
        .catch(error => {
          console.log('There was an error:', error.response)
        }
      )

      // 모든 점포정보 가져오기
      ServerApiCallService.tempStores()
        .then(response => {
          thisObj.stores = response.data.stores
          // 初期表示時の
          this.loadingData = false
        })
        .catch(error => {
          console.log('There was an error:', error.response)
        })
    },
    customFilter(items, search) {
      if (search.supplierName === '全て(使える店舗)') {
        // add kium 20231121: 사용하는 점포만 보여주기
        let activeStores = items.filter(function(value) {
          if (value.isDeleted === '0') {
            return true;
          } else {
            return false;
          }
        })

        return activeStores
      } else if (search.supplierName === '使えない店舗') {
        // add kium 20231121: 사용하지 않는 점포만 보여주기
        let inactiveStores = items.filter(function(value) {
          if (value.isDeleted === '1') {
            return true;
          } else {
            return false;
          }
        })

        return inactiveStores
      } else {
        let filteringItems = items.filter(function(value) {
          // add kium 20231121: 선택된 거래처의 사용하는 점포만 보여주기
          if (value.supplierCode === search.supplierCode && value.isDeleted === '0') {
            return true
          } else {
            return false
          }
        })        

        return filteringItems
      }
    },
    pickFile() {
      this.$refs.file.click()
    },
    onFileChange(e) {
      // const files = e.target.files
      this.targetFile = e.target.files[0]

      if (this.targetFile !== undefined) {
        this.fileName = this.targetFile.name
      }
    },
    forwardStoreEdit(storeRow) {
      this.$router.push({
        name: 'admin_stores_update',
        params: {
          storeCode: storeRow.storeCode,
          isUpdateMode: true
        }
      })
    },
    fileUpload() {
      console.log('fileUpload')
      let thisObj = this
      // FormData を利用して File を POST する
      let formData = new FormData()
      formData.append('uploadFile', this.targetFile)
      formData.append('charsetName', this.fileFormat)

      let sendContext = {
        hasDialogComponent: this.$parent.$parent.$parent
      }

      this.$validator.validateAll().then(result => {
        if (!result) {
          this.$parent.$parent.$parent.showErrorDialog(this.$t('hasInputError'))
          return
        }
      })

      thisObj.loading1 = true
      ServerApiCallService.sendStoresTempFile(formData, sendContext)
        .then(response => {
          // 버튼의 빙글빙글 돌게 하는거
          thisObj.loading1 = false
          // 초기화면
          this.getAllStores();
        })
        .catch(error => {
          thisObj.loading1 = false
        })
    },    
    downloadCsv() {
      axios
        .create({
          baseURL: ServerApiCallService.getServerUrl(),
          withCredentials: false, // This is the default
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json;charset=utf-8',
            accessToken: window.localStorage.getItem('accessToken')
          }
        })
        .get('/admin/stores-temp-download', {
          responseType: 'blob'
        })
        .then(({ data }) => {
          let blob = new Blob([data], { type: 'text/csv' })
          let link = document.createElement('a')
          link.href = window.URL.createObjectURL(blob)
          link.download = '店舗一覧.csv'
          link.click()
        })
    },
  },
  data() {
    return {
      loadingData: false,
      dispDeleted: 'info',
      stores: [],
      suppliers: [],
      selectSupplier: {
        supplierCode: '#',
        supplierName: '全て(使える店舗)'
      },
      loading1: false,
      fileName: '',
      fileFormat: 'SHIFT-JIS',
      headers: [
        {
          text: '店舗名',
          align: 'left',
          sortable: false,
          value: 'storeName',
          width: '100px',
          fixed: true
        },
        {
          text: '納入先コード',
          align: 'left',
          sortable: false,
          value: 'deliveryCode',
          width: '30px'
        },
        {
          text: '郵便番号',
          align: 'left',
          sortable: false,
          value: 'postCode',
          width: '30px'
        },
        {
          text: '配送業者者コード',
          align: 'center',
          sortable: false,
          value: 'shippingCarrierCode',
          width: '30px'
        },
        {
          text: '配送ルートコード1',
          align: 'center',
          sortable: false,
          value: 'deliveryRouteCode1',
          width: '30px'
        },
        {
          text: '配送ルートコード2',
          align: 'center',
          sortable: false,
          value: 'deliveryRouteCode2',
          width: '30px'
        }
      ]
    }
  }
}
</script>

<style>
.column-input {
  width: 100% !important;
  height: 30px;
  text-align: right;
  border: 1px solid #c7c7c7;
  padding: 0 4px;
}
</style>
